/** Inline "View p.N" link that opens the source PDF at the given page in a new tab. */
import type { MouseEvent } from "react";
import { Button } from "@cloudscape-design/components";
import { openPdfAtPage } from "@/core/api/pdf";

export function PdfPageLink({ reportId, page }: { reportId: string; page: number }) {
  // The link often lives inside an ExpandableSection header; without this
  // wrapper the click bubbles up and toggles the card open/closed.
  const stop = (e: MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <span onClick={stop} onMouseDown={stop}>
      <Button variant="inline-link" iconName="external" onClick={() => void openPdfAtPage(reportId, page)}>
        View p.{page}
      </Button>
    </span>
  );
}
